import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Banner } from '../Banner/Banner';

const StyledBanner = styled('div')(({ theme }) => ({
    paddingBlock: theme.spacing(1)
}));

interface StalePlanBannerProps {
    onRefresh: () => void;
    // Optional overrides for non-plan contexts (e.g. /admin tenant configurations).
    message?: string;
    refreshLabel?: string;
}

// AEX-3363: shown in place of the generic save-error banner when the backend rejects a save because
// the plan was changed in another tab (reference-ID mismatch). Reuses the shared "warning" Banner
// (warning-triangle icon + bold "Attention needed:" prefix + right-aligned CTA). "Refresh Plan"
// re-fetches the latest plan so the advisor can re-apply their change on top of the fresh data.
export const StalePlanBanner = ({ onRefresh, message, refreshLabel }: StalePlanBannerProps) => {
    const { t } = useTranslation();
    return (
        <StyledBanner>
            <Banner
                type="warning"
                message={message ?? t('STALE_PLAN_BANNER_MSG')}
                handleTryAgain={onRefresh}
                hyperlinkLabelText={refreshLabel ?? t('REFRESH_PLAN')}
            />
        </StyledBanner>
    );
};
